<script>
	import { onMount } from 'svelte';
	import { fetchAPI } from '../../../lib/fetchAPI';

	export let data;

	let suggest = true;

	// onMount(async () => {
	// 	let payload = {
	// 		category_id: data.category_id,
	// 		blog_id: data.id
	// 	};
	// 	let res = await fetchAPI('/communitychronicle/list_relevant/', 'POST', payload, false);
	// 	suggest = await res.json();
	// });
	
	function formatUrl(scale, img_id) {
		let formatedUrl = `${import.meta.env.VITE_API_URL}/communitychronicle/image/${img_id}?scaley=${scale}&encoding=webp`;
		return formatedUrl;
	}


	function handleEncodeCaracters(s) {
		return s.replace(/&#8217;/g, "'");
	}
</script>

{#if suggest != false}
	{#each data as blog}
		<a href="{import.meta.env.VITE_URL}/communitychronicle/{blog.slug}">
			<div class="card">
				<img src="{formatUrl(475, blog.blog_images[0].id)}" alt="" />
				<div>
					<h1>{handleEncodeCaracters(blog.subject)}</h1>
				</div>
			</div>
		</a>
	{/each}
{/if}

<style>
	a {
		all: unset;
		cursor: pointer;
	}
	.card {
		background: #ffffff;
		box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
		border-radius: 20px;
		width: 253px;
		height: 241px;
	}

	.card img {
		border-radius: 20px 20px 10px 10px;
		width: 100%;
		height: 151px;
	}

	.card div {
		text-align: center;
		display: flex;
		justify-content: center;
	}

	.card h1 {
		color: #667779;
		font-weight: 600;
		font-size: 16px;
		line-height: 22px;
		width: 230px;
		height: 44px;
	}

	@media only screen and (max-width: 1228px) {
		.card {
			width: 220px;
		}

		.card h1 {
			width: 100%;
		}
	}

	@media only screen and (max-width: 825px) {
		.card {
			min-width: 300px;
		}
	}
</style>
